export default {
  attributeId: "",
  formId: "",
  options: {
    title: "Untitled",
    type: "new_field",
  },
};
